import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Input, Button } from '@getpay93/ui';
import { api } from '../lib/api';

export function Recuperar() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.auth.forgotPassword(email);
    } catch {
      // Mensaje genérico igual (no revelar si el correo existe).
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-strong)', marginTop: 0 }}>Recuperar contraseña</h1>
        {sent ? (
          <p style={{ color: 'var(--text-muted)' }}>Si el correo existe, te enviamos un enlace. <strong>Revisa tu correo</strong> y sigue el link para crear una nueva contraseña.</p>
        ) : (
          <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <p style={{ color: 'var(--text-muted)', margin: 0, fontSize: 14 }}>Te enviaremos un enlace para restablecerla.</p>
            <Input placeholder="Correo" type="email" value={email} onChange={(e) => setEmail(e.currentTarget.value)} required />
            <Button type="submit" fullWidth disabled={busy}>{busy ? 'Enviando…' : 'Enviar enlace'}</Button>
          </form>
        )}
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}><Link to="/login">Volver a iniciar sesión</Link></p>
      </Card>
    </div>
  );
}
